import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const piCreateIssueEmbedRoute: InvariantJiraRoute = {
	name: 'pi-issue-create-embed',
	path: '/jira/issues/create/pi/embed',
};
